module.exports = __webpack_public_path__ + "img/1-2.1acf60c7.svg";